export const usePolygons = ({
        setShowAreaDetailsPanel,
        mapLib, map, coreLib, areasRef, setAreaSelected
    }) => {

    const createPolygon = ({id, position, paths, editable = true, draggable = true, name = "", color = "#FF0000", observation = ""}) => {

        let coordinates
        if (position) {
            const lat = Number(position.lat);
            const lng = Number(position.lng);

            coordinates = [
                {lat: lat - 0.008, lng: lng + 0.008},
                {lat: lat + 0.008, lng: lng + 0.008},
                {lat: lat + 0.008, lng: lng - 0.008},
                {lat: lat - 0.008, lng: lng - 0.008},
            ];
        }

        const polygon = new mapLib.Polygon({
            id,
            paths: paths || coordinates,
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: color,
            fillOpacity: 0.35,
            editable,
            draggable,
        });

        polygon.setMap(map);

        coreLib.event.addListener(polygon, 'click', () => {
            const area = areasRef.current.find(a => a.id === id);

            setShowAreaDetailsPanel(true)

            polygon.setOptions({
                editable: true,
                draggable: true,
            });

            areasRef.current.forEach(a => {
                if (a.id !== id) removeEditableDraggable(a)
            })

            setAreaSelected(area)
        });

        return {id, polygon, data: { name, color, observation}}
    }

    const removeEditableDraggable = (areaSelected) => {
        if (areaSelected) {
            areaSelected.polygon.setOptions({
                editable: false,
                draggable: false,
            });
        }
    }

    const removePolygon = (polygon) => {
        if (polygon) polygon.setMap(null);
    }

    return { createPolygon, removeEditableDraggable, removePolygon}
}
